import { WorkOrderChangeStatusProps } from 'constantsProject';
import type { BimWorkOrderChangeDefaultsQuery, BimWorkOrderChangeQuery, Maybe } from 'gql/graphql';
import { formatDateToLocale, formatNumberToRu, newDate } from 'utils';

import type { FieldValuesBimWorkOrderChangeCreateOrEditStructure } from './types';

export const mapDataToForm = ({
    defaultsData,
    workOrderChangeData,
}: {
    defaultsData: Maybe<BimWorkOrderChangeDefaultsQuery['bimWorkOrderChangeDefaults']['data'] | undefined>;
    workOrderChangeData: Maybe<BimWorkOrderChangeQuery['bimWorkOrderChange']['data'] | undefined>;
}): FieldValuesBimWorkOrderChangeCreateOrEditStructure | null => {
    if (defaultsData) {
        return {
            status: WorkOrderChangeStatusProps[defaultsData.status],
            subject: defaultsData.subject,
            internalNumber: undefined,
            authoredBy: defaultsData.authoredBy,
            updatedAt: formatDateToLocale(defaultsData.createdAt),
            signingDate: newDate(undefined),
            comment: undefined,
            ...defaultsData.seasonDistributions.reduce<Record<`season_${string}`, string>>(
                (acc, { year, seasonValue }) => ({
                    ...acc,
                    [`season_${year}`]: `${formatNumberToRu(seasonValue, 2) ?? 0} %`,
                }),
                {},
            ),
        };
    }

    if (workOrderChangeData) {
        return {
            status: WorkOrderChangeStatusProps[workOrderChangeData.status],
            subject: workOrderChangeData.subject,
            internalNumber: workOrderChangeData.internalNumber,
            authoredBy: workOrderChangeData.authoredBy,
            updatedAt: formatDateToLocale(workOrderChangeData.updatedAt ?? workOrderChangeData.createdAt),
            signingDate: newDate(workOrderChangeData.signingDate),
            comment: workOrderChangeData.comment,
            ...workOrderChangeData?.seasons.reduce<Record<`season_${string}`, string>>(
                (acc, { id, workOrderSeason }) => {
                    if (workOrderSeason?.year) {
                        acc[`season_${workOrderSeason.year}`] = `${
                            formatNumberToRu(
                                workOrderChangeData.seasonDistributions.find(
                                    ({ workOrderChangeSeasonId }) => workOrderChangeSeasonId === id,
                                )?.seasonValue,
                                2,
                            ) ?? 0
                        } %`;
                    }

                    return acc;
                },
                {},
            ),
        };
    }

    return null;
};
